module.exports = __webpack_public_path__ + "img/cybersecurity-img-2.067521ab.jpg";